{
  "greeting": {
    "morning": "Good morning, {name}",
    "afternoon": "Good afternoon, {name}",
    "evening": "Good evening, {name}",
    "late": "Working late, {name}"
  },
  "summary": "You have {open} pending across {projects} projects",
  "progress_completed": "Completed this month",
  "stats": {
    "open_tasks": "Open tasks",
    "due_today": "Due today",
    "due_today_card": "Due today",
    "overdue": "Overdue",
    "completed_week": "Completed this week",
    "projects": "Projects",
    "collaborators": "Collaborators"
  },
  "todays_tasks": {
    "title": "Priorities",
    "view_all": "View all",
    "empty_title": "All caught up!",
    "empty_subtitle": "You have no overdue tasks"
  },
  "my_tasks": {
    "title": "My tasks",
    "view_all": "View all",
    "empty": "No tasks assigned to you. Enjoy!",
    "due": "Due {date}",
    "no_due": "No due date"
  },
  "collaborators": {
    "title": "Your team",
    "title_short": "Team",
    "view_all": "View all",
    "empty": "Invite someone to start collaborating.",
    "empty_title": "No collaborators",
    "empty_subtitle": "Invite members to your team",
    "open_tasks": "{n} open task | {n} open tasks",
    "open_count_title": "{n} open task assigned | {n} open tasks assigned"
  },
  "recent_projects": {
    "title": "Recent projects",
    "view_all": "View all",
    "empty": "No recent projects.",
    "create_first": "Create the first one",
    "empty_title": "No projects yet",
    "empty_subtitle": "Create your first project to get started",
    "create_action": "Create project",
    "no_description": "No description.",
    "tasks_count": "{n} task | {n} tasks"
  },
  "oem_modal": {
    "title": "Recording interrupted",
    "body": "Your last recording was interrupted because the system closed Tworks.",
    "body_with_oem": "This usually happens on {label} with aggressive battery optimization.",
    "activate_bypass": "Enable bypass",
    "close": "Close"
  }
}
